import axios from 'axios'

const RESET = 'RESET'
const GET_GRADE_DATA_AND_CONFIGURATION = 'GET_GRADE_DATA_AND_CONFIGURATION'
const ADD_GRADE_DATA = 'ADD_GRADE_DATA'
const UPDATE_GRADE_DATA = 'UPDATE_GRADE_DATA'
const DELETE_GRADE_DATA = 'DELETE_GRADE_DATA'
const ADD_GRADE_CONFIGURATION = 'ADD_GRADE_CONFIGURATION'
const UPDATE_GRADE_CONFIGURATION = 'UPDATE_GRADE_CONFIGURATION'
const DELETE_GRADE_CONFIGURATION = 'DELETE_GRADE_CONFIGURATION'

const BASE_URL_getGradeAndConfiguration = (Id = '') => `api/ContinuousDataGrade/GetGradeDataAndConfiguration/${Id}`
const BASE_URL_addGradeData = 'api/ContinuousDataGrade/AddDataGrade'
const BASE_URL_updateGradeData = 'api/ContinuousDataGrade/UpdateDataGrade'
const BASE_URL_deleteGradeData = (Id = '') => `api/ContinuousDataGrade/DeleteDataGrade/${Id}`
const BASE_URL_addConfiguration = 'api/ContinuousDataGrade/AddGradeConfiguration'
const BASE_URL_updateConfiguration = 'api/ContinuousDataGrade/UpdateGradeConfiguration'
const BASE_URL_deleteConfiguration = (Id = '') => `api/ContinuousDataGrade/DeleteGradeConfiguration/${Id}`

function initialState () {
  return {
    ContinuousDataGrades: [],
    ContinuousGradeConfigurations: [],
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getGradeDataAndConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_getGradeAndConfiguration(options)
        let res = await axios.get(url)
        commit(GET_GRADE_DATA_AND_CONFIGURATION, res.data)
      }
      catch(error) {
        console.error(error)
      }
    },
    async addGradeData({ commit }, options) {
      try {
        let url = BASE_URL_addGradeData
        let res = await axios.post(url, options.data)
        commit(ADD_GRADE_DATA, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async updateGradeData({ commit }, options) {
      try {
        let url = BASE_URL_updateGradeData
        let res = await axios.post(url, options.data)
        commit(UPDATE_GRADE_DATA, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async deleteGradeData({ commit }, options) {
      try {
        let url = BASE_URL_deleteGradeData(options.data)
        await axios.delete(url)
        commit(DELETE_GRADE_DATA, options.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async addGradeConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_addConfiguration
        let res = await axios.post(url, options.data)
        commit(ADD_GRADE_CONFIGURATION, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async updateGradeConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_updateConfiguration
        let res = await axios.post(url, options.data)
        commit(UPDATE_GRADE_CONFIGURATION, res.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
    async deleteGradeConfiguration({ commit }, options) {
      try {
        let url = BASE_URL_deleteConfiguration(options.data)
        await axios.delete(url)
        commit(DELETE_GRADE_CONFIGURATION, options.data)
        options.successCb()
      }
      catch(error) {
        console.error(error)
        options.failedCb(error.response.data.Message)
      }
    },
  },

  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [GET_GRADE_DATA_AND_CONFIGURATION](state, data) {
      data.ContinuousGradeConfigurations.forEach(x => x.ContinuousDataGrades = [])
      data.ContinuousDataGrades.forEach(x => {
        if (x.GradeConfigurationId) {
          let target = data.ContinuousGradeConfigurations.find(y => y.Id == x.GradeConfigurationId)
          target.ContinuousDataGrades.push(x)
        }
      })
      state.ContinuousDataGrades = data.ContinuousDataGrades
      state.ContinuousGradeConfigurations = data.ContinuousGradeConfigurations
    },
    [ADD_GRADE_DATA](state, data) {
      state.ContinuousDataGrades.push(data)
    },
    [UPDATE_GRADE_DATA](state, data) {
      let index = state.ContinuousDataGrades.findIndex(x => x.Id == data.Id)
      state.ContinuousDataGrades.splice(index, 1, data)
      if (data.GradeConfigurationId) {
        let targetConfiguration = state.ContinuousGradeConfigurations.find(x => x.Id == data.GradeConfigurationId)
        let targetIndex = targetConfiguration.ContinuousDataGrades.findIndex(x => x.Id == data.Id)
        targetConfiguration.ContinuousDataGrades.splice(targetIndex, 1, data)
      }
    },
    [DELETE_GRADE_DATA](state, data) {
      let index = state.ContinuousDataGrades.findIndex(x => x.Id == data)
      state.ContinuousDataGrades.splice(index, 1)
    },
    [ADD_GRADE_CONFIGURATION](state, data) {
      let ContinuousDataGrades = []
      data.ContinuousDataGrades.forEach(x => {
        state.ContinuousDataGrades.forEach(e => {
          if (e.Id == x.Id) {
            e.GradeConfigurationId = data.Id
          }
        })
        ContinuousDataGrades.push({
          Id: x.Id,
          GradeValue: x.GradeValue,
          ShouldFilter: x.ShouldFilter,
          TenantId: x.TenantId,
          GradeConfigurationId: data.Id,
        })
      })
      state.ContinuousGradeConfigurations.push({
        Id: data.Id,
        Code: data.Code,
        Description: data.Description,
        TenantId: data.TenantId,
        ContinuousDataGrades: ContinuousDataGrades,
      })
    },
    [UPDATE_GRADE_CONFIGURATION](state, data) {
      state.ContinuousDataGrades.forEach(x => {
        if (x.GradeConfigurationId == data.Id) {
          x.GradeConfigurationId = null
        }
      })
      state.ContinuousDataGrades.forEach(x => {
        data.ContinuousDataGrades.forEach(y => {
          if (x.Id == y.Id) {
            x.GradeConfigurationId = data.Id
          }
        })
      })
      let index = state.ContinuousGradeConfigurations.findIndex(x => x.Id == data.Id)
      state.ContinuousGradeConfigurations.splice(index, 1, data)
    },
    [DELETE_GRADE_CONFIGURATION](state, data) {
      let index = state.ContinuousGradeConfigurations.findIndex(x => x.Id == data)
      state.ContinuousGradeConfigurations.splice(index, 1)
      state.ContinuousDataGrades.forEach(x => {
        if (x.GradeConfigurationId == data) {
          x.GradeConfigurationId = null
        }
      })
    },
  },

  getters: {
    ContinuousDataGrades: state => state.ContinuousDataGrades,
    ContinuousGradeConfigurations: state => state.ContinuousGradeConfigurations,
    allValueItem: state => {
      let arr1 = []
      let arr2 = []
      state.ContinuousDataGrades.map(e => {
        if (e.ShouldFilter == false) {
          arr1.push(e.GradeValue)
        }
      })
      state.ContinuousGradeConfigurations.map(e => {
        e.ContinuousDataGrades.map(f => arr2.push(f.GradeValue))
      })
      let RemoveSame = [...new Set([...arr1, ...arr2])]
      let SamePart = arr1.filter(item => arr2.includes(item))
      let Difference = RemoveSame.filter(item => !SamePart.includes(item))
      return Difference.sort()
    },
  },
}
